import { type ValueOf } from "../../types/utility/ValueOf";

export const status = {
  IDLE: "idle",
  PENDING: "pending",
  FAILED: "failed",
} as const;

export type Status = ValueOf<typeof status>;
